<template>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>偏好设置</span>
        <div class="elrows" v-if="false">
            <el-button size="small" icon="el-icon-plus" @click="addEx" style="background-color:#2174ff;border-color:#2174ff;color:#fff;font-size:14px;">添加知识点</el-button>
            <el-button size="small" icon="el-icon-plus" @click="addEx2" style="background-color:#24C358;border-color:#24C358;color:#fff;font-size:14px;">添加章节</el-button>
        </div>
      </div>
      <div class="boxxx" v-if="subjectBox">
          <div class="transition-box">
              <div class="head">添加偏好设置<p @click="closeS"><img src="../../../assets/images/newimg/close.png" alt=""></p></div>
              <div class="content">
                  <ul>
                      <li>添加知识点属性：</li>
                      <li>
                          <el-cascader
                              :options="treeData"
                              :props="defaultProps"
                              ref="scalectT"
                              @change="getTreeId"
                              separator=' > '
                              >
                          </el-cascader>
                      </li>
                      <li>
                          <el-button :loading="loading" type="warning" @click="preserCon">创建</el-button>
                      </li>
                  </ul>
              </div>

          </div>
      </div>
      <div class="boxxx" v-if="subjectBox2">
          <div class="transition-box">
              <div class="head">添加偏好设置<p @click="closeS"><img src="../../../assets/images/newimg/close.png" alt=""></p></div>
              <div class="content">
                  <ul>
                      <li>添加章节属性：</li>
                      <li>
                          <el-cascader
                              :options="treeData2"
                              :props="defaultProps2"
                              ref="scalectJ"
                              @change="getTreeId2"
                              separator=' > '
                              >
                          </el-cascader>
                      </li>
                      <li>
                          <el-button :loading="loading" type="warning" @click="preserCon2">创建</el-button>
                      </li>
                  </ul>
              </div>

          </div>
      </div>
      <!-- 偏好 -->
      <div class="noshow" v-if="this.subjects==''" v-loading="loading">
          <span>您尚未设置学科分类的偏好</span>
          <p><img src="../../../assets/images/portal/noex.png" alt=""></p>
      </div>
      <div class="headerBut" v-loading="loading" v-else>
        <div class="headerAlert" v-if="showTips">
          <ul>
            <li><img src="../../../assets/images/newimg/tipsS.png" alt=""></li>
            <li>当您设置偏好成功后，返回首页即可生效，每次登陆时，将会展开您所设置的偏好。</li>
            <li @click="displayN"><img src="../../../assets/images/newimg/close.png" alt=""></li>
          </ul>
        </div>
        <div class="userSubject" v-for="(item,index) in subjects" :key="index" :class="{'userSubjectSelection' : item.status == 1}" v-loading="loading">
          <div class="subjectExhibition">
            <dl>
              <dt>偏好:</dt>
              <dd>{{item.nodeNames}}</dd>
            </dl>
            <dl>
              <dt :class="{'changeColor' : item.type == 1}">类型:</dt>
              <dd :class="{'changeColor' : item.type == 1}">{{item.type | isUse}}</dd>
            </dl>
          </div>
          <div class="subjectOperation" v-if="false">
            <div class="useSubjects" v-if="item.status == 0" @click="confirmation(item)">使用</div>
            <div class="useSubjectsT" v-else>使用中</div>
            <div class="delete" @click="delePreference(item)">删除</div>
          </div>
        </div>
        <div class="paginations">
          <el-pagination
              background
              hide-on-single-page
              layout="prev, pager, next"
              :total="pageData.total"
              @current-change="pageChange"
              :page-size='5'
              >
          </el-pagination>
        </div>
      </div>
    </el-card>
</template>

<script>
import request from '@/utils/request'
import $ from 'jquery'

export default {
  data(){
    return{
      loadingS: false,
      showTips:false,
      pageData:{
        pagesize:5,
        pagenumber:0,
        total:0,
      },
      treeIds:'',
      chapterTreeIds:'',
      // 知识点请求
      treeData: [],
      treeData2: [],
      defaultProps: {
          value:'id',
          children: 'children',
          label: 'chapterName',
          checkStrictly: true,
      },
      defaultProps2: {
          value:'id',
          children: 'children',
          label: 'chapterName',
          checkStrictly: true,
      },
      subjectBox:false,
      subjectBox2:false,
      // subjects
      subjects:{},
      // tree
      treeid:[],
      eduIdj:'',
      eduIdz:'',
      eduIdzNode:'',
      loading:false,
      user:{},
    }
  },
  created(){
    this.getinfo();
  },
　filters: {
    isUse: function (value) {
        if(value==0){
            return '知识点'
        }else if(value==1){
            return '章节'
        }
    },
　},
  methods:{
    // 获取treeId
    getTreeId(value){
      this.treeIds = this.$refs.scalectT.getCheckedNodes()[0].value
    },
    getTreeId2(value){
      this.chapterTreeIds = this.$refs.scalectJ.getCheckedNodes()[0].value
    },
    //获取侧边栏:按知识点
    getTrees(){
        var _this = this;
        _this.loadingS=true;
        request({
            url: 'api/trees/trees?'+'noderes=0',
            methods: 'get'
        }).then(function(res){
            _this.treeData = res.data;
            _this.loadingS = false
        })
    },
    //获取侧边栏:章节
    getChapterTrees(){
        var _this = this;
        _this.loadingS=true;
        request({
            url: 'api/chaptertrees/chaptertrees?'+'noderes=0',
            methods: 'get'
        }).then(function(res){
            _this.treeData2 = res.data;
            _this.loadingS=false
        })
    },
    addEx(){
      this.subjectBox = true
      this.getTrees();
    },
    addEx2(){
      this.subjectBox2 = true
      this.getChapterTrees();
    },
    // 创建知识点偏好
    preserCon(){
      if(this.treeIds == ''){
        this.$notify({
          message: '尚未选择知识点偏好！',
          type: 'error',
          duration: 1500
        })
      }else{
        let knowledge = {}
        knowledge.treeId = this.treeIds;
        knowledge.userId = this.user.id;
        knowledge.type = 0;
        knowledge.status = 0;
        request({
          method:'post',
          url:'api/user/addSubject',
          data:knowledge
        }).then(res=>{
          if(res.code == 200){
            this.$notify({
              message: '知识点添加成功',
              type: 'success',
              duration: 1500
            })
            this.getOptions();
            this.subjectBox = false
            this.treeIds = ''
          }else if(res.code == 400){
            this.$notify({
              message: '当前偏好已存在',
              type: 'error',
              duration: 1500
            })
          }
        })
      }
    },
    // 创建章节偏好
    preserCon2(){
      if(this.chapterTreeIds == ''){
        this.$notify({
          message: '尚未选择章节偏好！',
          type: 'error',
          duration: 1500
        })
      }else{
        let knowledge = {}
        knowledge.treeId = this.chapterTreeIds;
        knowledge.userId = this.user.id;
        knowledge.type = 1;
        knowledge.status = 0;
        request({
          method:'post',
          url:'api/user/addSubject',
          data:knowledge
        }).then(res=>{
          if(res.code == 200){
            this.$notify({
              message: '章节添加成功',
              type: 'success',
              duration: 1500
            })
            this.getOptions();
            this.subjectBox2 = false
            this.chapterTreeIds = ''
          }else if(res.code == 400){
            this.$notify({
              message: '当前偏好已存在',
              type: 'error',
              duration: 1500
            })
          }
        })
      }
    },
    // 关闭
    closeS(){
      this.subjectBox = false
      this.subjectBox2 = false
      this.chapterTreeIds = ''
      this.treeIds = ''
    },
    displayN(){
      $('.headerAlert').fadeOut();
    },
    // 确认更换使用和未使用
    confirmation(item){
      let state = {}
      state.id = item.id
      state.nodeNames = item.nodeNames
      state.status = 1
      state.treeId = item.treeId
      state.type = item.type
      state.userId = item.userId
      request({
        method:'put',
        url:'api/userSubject',
        data:state
      }).then(res=>{
        if(res.code == 200){
          this.$notify({
            message:'偏好已更换成功',
            type:'success',
            duration: 1500
          })
          this.getOptions();
        }
      })
    },
    // 删除偏好
    delePreference(item){
        this.$confirm('是否删除该知识点/章节偏好！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'messageBox-btnF',
          confirmButtonClass: 'messageBox-btnT',
          type: 'warning'
        }).then(() => {
          request({
              method:'delete',
              url:'api/userSubject/'+item.id
            }).then(res=>{
              this.$notify({
                message:'删除知识点偏好成功',
                type:'success',
                duration:1500
              })
              let totalPage = Math.ceil(((this.pageData.total -1) / this.pageData.pagesize)-1)
              let currentPage = this.pageData.pagenumber > totalPage ? totalPage : this.pageData.pagenumber
              this.pageData.pagenumber = currentPage < 0 ? 0 : currentPage
              this.getOptions()
          })
        })
    },
    //获取到info
    getinfo(){
      request({
          method:'get',
          url:'auth/info'
      }).then(res=>{
          this.user = res.jwtUser
          this.getOptions();
      })
    },
    // 查看已选项
    getOptions(){
      setTimeout(() => {
        this.showTips = true
        $(".headerAlert").fadeIn();
      }, 100);
      this.loading = true
      request({
        method:'get',
        url:'api/user/subject/'+this.user.id+'?page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize
      }).then(res=>{
        this.subjects = res.data.content
        var temp = {}
        temp.pagesize=this.pageData.pagesize;
        temp.pagenumber=this.pageData.pagenumber;
        temp.total =Number(res.data.totalElements);
        this.pageData=temp
        this.loading = false
      })
    },
    // 页数切换
    pageChange(data){
        this.pageData.pagenumber = data-1;
        this.getOptions();
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import './preference.css';
  @import '../../../components/styles/pad.css';
  .elrows{
    float: right;
    margin-top: -6px;
  }
  .paginations{
      width: 100%;
      float: left;
      padding: 10px 20px;
      margin-bottom: 20px;
      text-align: center;
  }
  .paginations>.el-pagination{
      width: 100%;
      padding: 0;
      font-weight: 400;
  }
  /* 分页 */
  .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
      background:#2174ff;
      color: #fff;
  }
  .el-card /deep/ .el-card__body{
    height: auto;
  }
  .el-tree{
    width: 70%;
    float: left;
    z-index: 10;
  }
  .treebuts{
    width: 30%;
    float: left;
    text-align: center;
    .el-button+.el-button{
      margin-left: 0px;
    }
    .el-select{
      width: 90%;
    }
  }
  .treebut{
    margin-top: 10px;
    width:90%;
  }
  .headerBut{
      float: left;
      width: 100%;
      padding: 12px 20px;
  }
  .box2{
    color: #ec6f28;
  }
  /* 提示信息 */
  .noshow{
      height: auto;
      text-align: center;
      margin-top: 166px;
  }
  .noshow>span{
      font-size: 32px;
      color: #999;
  }
  .noshow>p{
      margin-top: 69px;
      margin-bottom: 158px;
      width: 593px;
      height: 349px;
      position: relative;
      left: 50%;
      transform: translateX(-50%);
  }
  .noshow>p>img{
      width: 100%;
      height: 100%;
  }
  @media (max-width: 1024px){
    .headerBut ul li:last-of-type{
      display: none;
    }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1367px) and (max-width:1440px){
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 117px;
    }
    .noshow>span{
        font-size: 26px;
        color: #999;
    }
    .noshow>p{
        margin-top: 55px;
        margin-bottom: 96px;
        width: 474px;
        height: 279px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 166px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 158px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 182px;
    }
    .noshow>span{
        font-size: 34px;
        color: #999;
    }
    .noshow>p{
        margin-top: 74px;
        margin-bottom: 122px;
        width: 633px;
        height: 372px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media (min-width:2049px){
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 248px;
    }
    .noshow>span{
        font-size: 44px;
        color: #999;
    }
    .noshow>p{
        margin-top: 92px;
        margin-bottom: 246px;
        width: 791px;
        height: 465px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/simple/simple3.vue